export default __webpack_public_path__ + "static/media/GWAS-locus.dd87f0ad.png";